export default __webpack_public_path__ + "static/media/031-css.d237bf29.svg";